// @ts-nocheck
// import { ButtonPresentationProps } from "@insite/mobius/Button"; // Foundation
import { IconPresentationProps } from "@insite/mobius/Icon";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import {
    buttonFieldIconClickableStyles,
    buttonFieldIconStyles,
    buttonResetStyles,
} from "@store/Themes/common/mixins/button";
import { ButtonVariant } from "@toolkit/Framework/Types/Button";

/* Foundation --> */
import { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";
/* <-- Foundation */

// Store Custom Code - >
import ShoppingBagFill from "@store/Library/Components/Icons/ShoppingBag/ShoppingBagFill";
import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
import getColor from "@insite/mobius/utilities/getColor";
import { checkoutButtonsStyles } from "@store/Themes/common/mixins/button";
// <-- Majestic Custom Code

export const buttonResetProps: ButtonPresentationProps = {
    color: null as any,
    buttonType: null as any,
    shape: null as any,
    hoverMode: "none",
    activeMode: "none",
    css: buttonResetStyles(false),
};

export const buttonGetFieldIconProps = (
    src: IconPresentationProps["src"],
    variant?: ButtonVariant,
): TextFieldPresentationProps => ({
    iconProps: {
        src,
        css: buttonFieldIconStyles(),
    },
    iconClickableProps: {
        css: buttonFieldIconClickableStyles(variant),
    },
});

/* Foundation --> */
export const buttonGetHoverProps = (color: string): ButtonPresentationProps => ({
    hoverStyle: { color },
    activeStyle: { color },
});
// Store Custom Code - >
export const checkoutButtonsProps: ButtonPresentationProps = {
    size: buttonSizeVariants.large.height,
    icon: {
        src: ShoppingBagFill,
        position: "left",
    },
    css: css`
        ${checkoutButtonsStyles()}
    `,
};
// <-- Majestic Custom Code

export const productDetailButton: ButtonPresentationProps = {
    sizeVariant: "large",
    typographyProps: {
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: ${({ theme }) => theme.design.typography.size.base};
                        `,
                        null,
                        null,
                        css`
                            font-size: ${({ theme }) => theme.design.typography.size.larger};
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    css: css`
        ${({ theme }) => theme.button.primary.css}
        display: flex;
        align-items: center;

        ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        min-width: ${pxToRem(180)};
                        padding: 0 ${pxToRem(15)};
                    `,
                    css`
                        padding: 0 ${pxToRem(30)};
                    `,
                    css`
                        min-width: ${pxToRem(220)};
                    `,
                ],
                mediaOptions.min,
            )}

        ${ButtonIcon} {
            top: 0;
            width: ${pxToRem(24)};

            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-right: 1em;
                        `,
                        null,
                        null,
                        css`
                            margin-right: 1.5em;
                        `,
                    ],
                    mediaOptions.min,
                )}
        }
    `,
};
// Store Custom Code - >
export const carouselButtonStyle = (side: "right" | "left"): ButtonPresentationProps => ({
    // variant: "primary",
    css: css`
        flex-shrink: 0;
        width: ${pxToRem(34)};
        height: ${pxToRem(34)};
        border: 0;
        border-radius: 50%;
        padding: 0;
        z-index: 1;
        min-height: 0px;
        background-color: ${getColor("common.carouselBackground")};

        &:hover {
            transform: ${side === "right" ? "scale(1.25) translate(40%, -40%)" : "scale(1.25) translate(-40%, -40%)"};
            background-color: ${getColor("common.carouselBackground")};
        }

        ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        position: absolute;
                        ${side}: 0.75em;
                    `,
                    css``,
                    css`
                        position: absolute;
                        ${side}: 0.75em;
                    `,
                    css``,
                    css``,
                ],
                mediaOptions.min,
            )}
    `,
});
// <-- Majestic Custom Code
/* <-- Foundation */
